import { USER_TYPE, COMPANY_TYPE, SUBSCRIPTION_STATUS, SUBSCRIPTION_TYPE, PLAN_NAME } from "@/src/constant/login";

/**
 * Check if user is a corporate manager with seller access
 */
export const isCorporateManagerWithSellerAccess = (
  userType: string,
  companyType: string
): boolean => {
  return (
    userType === USER_TYPE.CORPORATE_MANAGER &&
    (companyType === COMPANY_TYPE.SELLER || companyType === COMPANY_TYPE.BOTH)
  );
};

/**
 * Check if subscription is in a canceled or finished state
 */
export const isSubscriptionCanceledOrFinished = (status: string): boolean => {
  return (
    status === SUBSCRIPTION_STATUS.CANCELED ||
    status === SUBSCRIPTION_STATUS.FINISHED
  );
};

/**
 * Check if user is on free trial
 */
export const isFreeTrialSubscription = (
  subscriptionType: string,
  planName?: string
): boolean => {
  return (
    subscriptionType === SUBSCRIPTION_TYPE.FREE &&
    planName === PLAN_NAME.FREE_TRIAL
  );
};

/**
 * Get home path based on company type
 */
export const getHomePathByCompanyType = (
  companyType: string,
  exporterPath: string,
  importerPath: string
): string => {
  return companyType === COMPANY_TYPE.BUYER ? importerPath : exporterPath;
};
